import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap'; // Added Row import
import {
  Card, CardBody,
} from '@/shared/components/Card';
import Select, { components } from 'react-select';

import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../context/AuthContext';


// Assuming CardTitleWrap and CardTitle are missing imports, define simple placeholders or import if you have them
// eslint-disable-next-line
const CardTitleWrap = ({ children }) => <div className="card-title-wrap">{children}</div>;
// const CardTitle = () => <h3>Add Agent</h3>;

const AddAgent = ({ onSubmit }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAdressProof, setSelectedAdressProof] = useState(null);
  const [selectedGstProof, setSelectedGSTProof] = useState(null);
  const [country, setCountry] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { apiGlobal } = useContext(AuthContext);

  const handleFileChange = (event, input, setSelected) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelected(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelected(null);
      input.onChange(null);
    }
  };


  const fetchCountryList = async () => {
    setIsLoading(true);
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

  return (
    <Col md={12} lg={12}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ gender: 'male' }}
      >
        {({ handleSubmit, form }) => (
          <FormContainer onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <CardTitleWrap>
                  {/* <CardTitle /> */}
                  <p><span style={{ color: 'red' }}>*{' '}</span>Marked Fields are Required</p>
                </CardTitleWrap>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Agent Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="agentName"
                          component="input"
                          type="text"
                          placeholder="Name"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Email Address<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="email"
                          component="input"
                          type="email"
                          placeholder="Email Address"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>
                        Phone Number<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="country_code"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                  isLoading={isLoading}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="phone_no"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                  // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                            // validate={value => 
                            // (value && value.length === 12 ? undefined : '12 digit phone required')}
                          />
                        </div>
                      </FormGroupField>
                    </FormGroup>
                  </Col>

                </Row>
                <Row>
                    
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>UAN<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uan"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={12} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="UAN"
                          required
                          style={{ height: '45px' }}
                          validate={value => (value ? undefined : 'Required')}
                         
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="location"
                          component="input"
                          type="text"
                          placeholder="Location"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Area<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="area"
                          component="input"
                          type="text"
                          placeholder="Area"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Line 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline1"
                          component="input"
                          type="text"
                          placeholder="Address Line 1"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Line 2</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline2"
                          component="input"
                          type="text"
                          placeholder="Address Line 2"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="city"
                          component="input"
                          type="text"
                          placeholder="City"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>State<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="state"
                          component="input"
                          type="text"
                          placeholder="State"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Select Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Pincode<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="pincode"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={6} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
                          }}
                          placeholder="Pincode"
                          required
                          style={{ height: '45px' }}
                          validate={value => (value ? undefined : 'Required')}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          render={({ input }) => (
                            <input
                              type="file"
                              accept="image/*"
                              onChange={e => handleFileChange(e, input, setSelectedImage)}
                              required
                            />
                        )}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedImage && (
                      <FormGroup>
                        <FormGroupLabel>Selected Logo</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedImage}
                            alt="Selected Logo"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="address_proof"
                          render={({ input }) => (
                            <input
                              type="file"
                              accept="image/*"
                              onChange={e => handleFileChange(e, input, setSelectedAdressProof)}
                            />
                        )}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedAdressProof && (
                      <FormGroup>
                        <FormGroupLabel>Selected Address Proof</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedAdressProof}
                            alt="Selected Address Proof"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gst_proof"
                          render={({ input }) => (
                            <input
                              type="file"
                              accept="image/*"
                              onChange={e => handleFileChange(e, input, setSelectedGSTProof)}
                            />
                        )}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedGstProof && (
                      <FormGroup>
                        <FormGroupLabel>Selected GST Proof</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedGstProof}
                            alt="Selected GST Proof"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                  )}
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST No</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gst_no"
                          component="input"
                          type="text"
                          placeholder="GST No"
                          maxLength={12}
                          pattern=".{12,12}"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Type</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gst_type"
                          component="input"
                          type="text"
                          placeholder="GST Type"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Default Markup<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="markup"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={3} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3);
                            if (e.target.value > 100) {
                              e.target.value = 100; // Limit to 100
                            }
                          }}
                          placeholder="Default Markup"
                          required
                          style={{ height: '45px' }}
                          validate={value => (value ? undefined : 'Required')}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX Identification<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxId"
                          component="input"
                          type="text"
                          placeholder="TAX Identification"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxCity"
                          component="input"
                          type="text"
                          placeholder="Tax City"
                          validate={value => (value ? undefined : 'Required')}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                  <Button variant="secondary" type="button" onClick={form.reset}>Reset</Button>
                </FormButtonToolbar>
              </CardBody>
            </Card>
          </FormContainer>
        )}
      </Form>
    </Col>
  );
};

AddAgent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(AddAgent);


// code before re-factor

// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { Field, Form } from 'react-final-form';
// import { Col } from 'react-bootstrap';
// import {
//   Card, CardBody,
// } from '@/shared/components/Card';
// import {
//   FormButtonToolbar,
//   FormContainer,
//   FormGroup,
//   FormGroupField,
//   FormGroupLabel,
//   FormHalfContainer,
// } from '@/shared/components/form/FormElements';
// import { renderMaskedField } from '@/shared/components/form/FormField';
// import { Button } from '@/shared/components/Button';

// const AddAgent = ({ onSubmit }) => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [selectedAdressProof, setSelectedAdressProof] = useState(null);
//   const [selectedGstProof, setSelectedGSTProof] = useState(null);

//   const handleFileChange = (event, input) => {
//     const file = event.target.files[0];
//     if (file && file.type.startsWith('image/')) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//       input.onChange(file);
//     } else {
//       setSelectedImage(null);
//       input.onChange(null);
//     }
//   };

//   const handAddressFileChange = (event, input) => {
//     const file = event.target.files[0];
//     if (file && file.type.startsWith('image/')) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedAdressProof(reader.result);
//       };
//       reader.readAsDataURL(file);
//       input.onChange(file);
//     } else {
//       setSelectedAdressProof(null);
//       input.onChange(null);
//     }
//   };

//   const handGstFileChange = (event, input) => {
//     const file = event.target.files[0];
//     if (file && file.type.startsWith('image/')) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedGSTProof(reader.result);
//       };
//       reader.readAsDataURL(file);
//       input.onChange(file);
//     } else {
//       setSelectedGSTProof(null);
//       input.onChange(null);
//     }
//   };

//   return (
//     <Col md={12} lg={12}>
//       <Card>
//         <CardBody>
//           <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
//           <Form onSubmit={onSubmit} horizantal initialValues={{ gender: 'male' }}>
//             {({ handleSubmit, form }) => (
//               <FormContainer onSubmit={handleSubmit}>
//                 <FormHalfContainer>
//                   <FormGroup>
//                     <FormGroupLabel>Agent Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="agentName"
//                         component="input"
//                         type="text"
//                         placeholder="Name"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Email Address<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="email"
//                         component="input"
//                         type="email"
//                         placeholder="Email Address"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
                  
//                   <FormGroup>
//                     <FormGroupLabel>Area<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="area"
//                         component="input"
//                         type="text"
//                         placeholder="Area"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>State<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="state"
//                         component="input"
//                         type="text"
//                         placeholder="State"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Pincode<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="pincode"
//                         component={renderMaskedField}
//                         mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//                         type="text"
//                         placeholder="Pincode"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="file"
//                         render={({ input }) => (
//                           <input
//                             type="file"
//                             onChange={e => handleFileChange(e, input)}
//                             required
//                           />
//                         )}
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   {selectedImage && (
//                     <FormGroup>
//                       <FormGroupLabel>Selected Logo</FormGroupLabel>
//                       <FormGroupField>
//                         <img
//                           src={selectedImage}
//                           alt="Selected Logo"
//                           style={{ maxWidth: '200px', maxHeight: '200px' }}
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                   )}
//                   {/* <FormGroup>
//                     <FormGroupLabel>Logo</FormGroupLabel>
//                     <FormGroupField
//                       style={{
//                         backgroundColor: '#8080807a',
//                         borderRadius: '5px',
//                         padding: '5px',
//                         border: 'none',
//                         marginLeft: '10px',
//                     }}
//                     >
//                       <Field
//                         name="file"
//                         render={({ input }) => (
//                           <div className="row g-2 align-items-center">
//                             <div className="col">
//                               <input
//                                 type="file"
//                                 className="form-control"
//                                 onChange={e => handleFileChange(e, input)}
//                                 accept="image/*"
//                               />
//                             </div>
//                             {selectedImage && (
//                               <div className="col-auto">
//                                 <div 
//                                   className="position-relative" 
//                                   style={{ 
//                                   height: '100px',
//                                 }}
//                                 >
//                                   <img
//                                     src={selectedImage}
//                                     alt="Selected Logo"
//                                     style={{ 
//                                       height: '100%',
//                                       width: '100%',
//                                       objectFit: 'contain',
//                                       backgroundColor: '#f8f9fa',
//                                       border: '1px solid #dee2e6',
//                                       borderRadius: '4px',
//                                       padding: '2px',
//                                     }}
//                                   />
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       />
//                     </FormGroupField>
//                   </FormGroup> */}
//                   <FormGroup>
//                     <FormGroupLabel>GST No</FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="gst_no"
//                         component="input"
//                         type="text"
//                         placeholder="GST No"
//                         maxLength={12} // Restricts input to 12 characters
//                         pattern=".{12,12}" // Ensures exactly 12 characters
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>GST Type</FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="gst_type"
//                         component="input"
//                         type="text"
//                         placeholder="GST Type"
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Address Proof</FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="address_proof"
//                         render={({ input }) => (
//                           <input
//                             type="file"
//                             onChange={e => handAddressFileChange(e, input)}
//                           />
//                         )}
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   {selectedAdressProof && (
//                     <FormGroup>
//                       <FormGroupLabel>Selected Address Proof</FormGroupLabel>
//                       <FormGroupField>
//                         <img
//                           src={selectedAdressProof}
//                           alt="Selected Address Proof"
//                           style={{ maxWidth: '200px', maxHeight: '200px' }}
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                   )}
//                   <FormGroup>
//                     <FormGroupLabel>GST Proof</FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="gst_proof"
//                         render={({ input }) => (
//                           <input
//                             type="file"
//                             onChange={e => handGstFileChange(e, input)}
//                           />
//                         )}
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   {selectedGstProof && (
//                     <FormGroup>
//                       <FormGroupLabel>Selected GST Proof</FormGroupLabel>
//                       <FormGroupField>
//                         <img
//                           src={selectedGstProof}
//                           alt="Selected Address Proof"
//                           style={{ maxWidth: '200px', maxHeight: '200px' }}
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                   )}
//                 </FormHalfContainer>
//                 <FormHalfContainer>
//                   <FormGroup>
//                     <FormGroupLabel>UAN<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="uan"
//                         component={renderMaskedField}
//                         type="text" // switch to text type
//                         mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//                         placeholder="UAN"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="phone_no"
//                         component={renderMaskedField}
//                         mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//                         type="text"
//                         placeholder="Enter 12 digit Phone Number"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <div className="row">
//                       <div className="col-md-6">
//                         <FormGroupLabel>
//                           Address Line 1<span style={{ color: 'red' }}>*</span>
//                         </FormGroupLabel>
//                         <FormGroupField>
//                           <Field
//                             name="addressline1"
//                             component="input"
//                             type="text"
//                             placeholder="Address Line 1"
//                             required
//                           />
//                         </FormGroupField>
//                       </div>
//                       <div className="col-md-6">
//                         <FormGroupLabel>
//                           Address Line 2
//                         </FormGroupLabel>
//                         <FormGroupField>
//                           <Field
//                             name="addressline2"
//                             component="input"
//                             type="text"
//                             placeholder="Address Line 2"
//                           />
//                         </FormGroupField>
//                       </div>
//                     </div>
//                   </FormGroup>

//                   <FormGroup>
//                     <div className="row">
//                       <div className="col-md-6">
//                         <FormGroupLabel>
//                           City<span style={{ color: 'red' }}>*</span>
//                         </FormGroupLabel>
//                         <FormGroupField>
//                           <Field
//                             name="city"
//                             component="input"
//                             type="text"
//                             placeholder="City"
//                             required
//                           />
//                         </FormGroupField>
//                       </div>
//                       <div className="col-md-6">
//                         <FormGroupLabel>
//                           Select your country<span style={{ color: 'red' }}>*</span>
//                         </FormGroupLabel>
//                         <FormGroupField>
//                           <Field
//                             name="country"
//                             component="input"
//                             type="text"
//                             placeholder="Country"
//                             required
//                           />
//                         </FormGroupField>
//                       </div>
//                     </div>
//                   </FormGroup>

//                   <FormGroup>
//                     <FormGroupLabel>Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="location"
//                         component="input"
//                         type="text"
//                         placeholder="Location"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>Default Markup<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="markup"
//                         component={renderMaskedField}
//                         type="text"
//                         mask={[/[0-9]/, /\d/, /\d/]}
//                         placeholder="Default Markup"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>TAX Identification<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="taxId"
//                         component="input"
//                         type="text"
//                         placeholder="TAX Identification"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
//                   <FormGroup>
//                     <FormGroupLabel>TAX City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                     <FormGroupField>
//                       <Field
//                         name="taxCity"
//                         component="input"
//                         type="text"
//                         placeholder="Tax City"
//                         required
//                       />
//                     </FormGroupField>
//                   </FormGroup>
                  
//                 </FormHalfContainer>
//                 <FormButtonToolbar>
//                   <Button variant="primary" type="submit">Submit</Button>
//                   <Button variant="secondary" type="button" onClick={form.reset}>
//                     Reset
//                   </Button>
//                 </FormButtonToolbar>
//               </FormContainer>
//             )}
//           </Form>
//         </CardBody>
//       </Card>
//     </Col>
//   );
// };

// AddAgent.propTypes = {
//   onSubmit: PropTypes.func.isRequired,
// };

// export default React.memo(AddAgent);
